import { configureStore } from '@reduxjs/toolkit'
import listingsReducer from './listingsSlice'
import authReducer from './authSlice'
import wineSearchReducer from './wineSearchSlice';
import vipReducer from './vipSlice';
import passportReducer from './passportSlice';


export const store = configureStore({
  reducer: {
    listings: listingsReducer,
    auth: authReducer,
    wineSearch: wineSearchReducer,
    vip: vipReducer,
    passport: passportReducer,
  },
})